import {DatePicker} from "antd";
import {Form} from "antd";

export const DateRangePickerFilter = ({name = 'dateRange', ...rest}) => {
    const form = Form.useFormInstance();

    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                <DatePicker.RangePicker
                    style={{
                        width: 250,
                    }}
                    format="YYYY-MM-DD"
                    onChange={form.submit}
                    {...rest}
                />
            </Form.Item>
        </>
    );
}